import { useState, useContext } from 'react'
import MenuItem from './MenuItem'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { CollapseArrowIcon } from '../../../components/1elements'
import { GlobalContext } from '../../../services/context/DataContext'

const CollapsableMenuItem = ({ children, props }) => {
  const [displayContent, setDisplayContent] = useState(true)
  const classes = useStyles({ displayContent })
  const { activeTabData } = useContext(GlobalContext)
  const [activeTab,] = activeTabData
  const menuClicked = activeTab === props.linkTo

  const toggle = () => setDisplayContent((prev) => !prev)

  return (
    <div className={classes.root}>
      <div className={classes.header} onClick={toggle}>
        <MenuItem props={props} noBottomBorder={true} />
        <CollapseArrowIcon
          className={`${classes.collapsableArrow} ${
            menuClicked && classes.arrowClicked
          }`}
          toggle={displayContent}
        />
      </div>
      {displayContent && (
        <div className={classes.content}>
          {children.map((menuItem, index) => (
            <MenuItem key={`${menuItem.name}${index}}`} props={menuItem} />
          ))}
        </div>
      )}
    </div>
  )
}

export default CollapsableMenuItem

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.quaternary.main,
      color: theme.palette.primary.accent
    }
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: (props) => (props.displayContent ? '500px' : '0'),
    opacity: (props) => (props.displayContent ? 1 : 0),
    transition: 'all 0.7s ease'
  },
  collapsableArrow: {
    borderRadius: 0,
    color: theme.palette.primary.accent,
    '&.MuiIconButton-root': {
      transition: 'none'
    },
    '&:hover': {
      borderRadius: 0,
      backgroundColor: theme.palette.quaternary.main,
      color: theme.palette.primary.accent
    }
  },
  noBorder: {
    border: 'none'
  },
  arrowClicked: {
    borderRadius: 0,
    backgroundColor: theme.palette.quaternary.main,
    color: theme.palette.primary.accent
  }
}))
